import {type FC, memo} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props as ModalProps} from '@src/components/ModalNew';

import Modal from '@src/components/ModalNew';

import type {Props as SelectCoachProps} from './SelectCoach';

import {SelectCoach} from './SelectCoach';

import styles from './SelectCoach.module.css';

type Props = Partial<ModalProps> & SelectCoachProps;

const SelectCoachModal: FC<Props> = ({
  canAcceptPayments,
  children,
  onSelect,
  selection,
  ...modalProps
}) => {
  const {t} = useI18n();

  return (
    <Modal
      bodyClassName={styles.modalBody}
      title={t('web-app:SelectCoach.title')}
      {...modalProps}
    >
      <SelectCoach
        canAcceptPayments={canAcceptPayments}
        onSelect={onSelect}
        selection={selection}
      />
      {children}
    </Modal>
  );
};

export default memo(SelectCoachModal);
